var NavigationActionHandler = /** @class */ (function () {
    function NavigationActionHandler(navigationElement, onNavigation) {
        this.navigationElement = navigationElement;
        this.onNavigation = onNavigation;
        this.__clickHandler = this.__getClickHandler();
    }
    NavigationActionHandler.prototype.__parentsOfNode = function (node) {
        var result = [node];
        var parent = node.parentElement;
        while (parent) {
            result.push(parent);
            parent = parent.parentElement;
        }
        return result;
    };
    NavigationActionHandler.prototype.__getClickHandler = function () {
        var _this = this;
        return function (event) {
            var hasLink = _this.__parentsOfNode(event.target).some(function (el) { return el.tagName.toLowerCase() === 'a' && !!el.href; });
            if (hasLink) {
                _this.onNavigation();
            }
        };
    };
    NavigationActionHandler.prototype.attach = function () {
        this.navigationElement.addEventListener('click', this.__clickHandler);
        this.navigationElement.addEventListener('awsui:follow', this.onNavigation);
    };
    NavigationActionHandler.prototype.detach = function () {
        this.navigationElement.removeEventListener('click', this.__clickHandler);
        this.navigationElement.removeEventListener('awsui:follow', this.onNavigation);
    };
    return NavigationActionHandler;
}());
export default NavigationActionHandler;
//# sourceMappingURL=navigationActionHandler.js.map